import { DsButton } from '@frontends/ds';
import { type BaseSyntheticEvent, memo } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OnboardingSchemaBasicInformationType } from '@/types/Onboarding.ts';
import BirthdayPicker from '../../components/BirthdayPicker.tsx';
import FormTextField from '../../components/FormTextField.tsx';

export const OnboardingBasicInfoUpdate = memo(function OnboardingBasicInfoUpdate({
  onboardingBasicInfoForm,
  onboardingBasicInfoOnSubmit,
  isPending,
}: {
  onboardingBasicInfoForm: UseFormReturn<OnboardingSchemaBasicInformationType>;
  onboardingBasicInfoOnSubmit: (data: OnboardingSchemaBasicInformationType, e?: BaseSyntheticEvent) => void;
  isPending: boolean;
}) {
  const { t } = useTranslation();

  return (
    <form onSubmit={onboardingBasicInfoForm.handleSubmit(onboardingBasicInfoOnSubmit)}>
      <div className="grid gap-6">
        <div className="grid gap-2">
          <FormTextField
            control={onboardingBasicInfoForm.control}
            name="first_name"
            id="first_name"
            label={t('first_name')}
            placeholder="John"
            isRequired
          />
        </div>
        <div className="grid gap-2">
          <FormTextField
            control={onboardingBasicInfoForm.control}
            name="last_name"
            id="last_name"
            label={t('last_name')}
            placeholder="Doe"
            isRequired
          />
        </div>
        <div className="grid gap-2">
          <Controller
            rules={{ required: true }}
            control={onboardingBasicInfoForm.control}
            name="birthday"
            render={({ field, fieldState }) => (
              <div className="flex flex-col gap-2">
                <BirthdayPicker
                  label={t('birthdate')}
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={fieldState.invalid}
                  errorMessage={fieldState.error?.message}
                />
              </div>
            )}
          />
        </div>
        <DsButton type="submit" size="lg" className="w-full" isPending={isPending}>
          {t('update_personal_info')}
        </DsButton>
      </div>
    </form>
  );
});
